module.exports = __webpack_public_path__ + "static/media/S1-14-Zardok-cod14.0ab21d01.png";